import { SiteHeader } from '@/components/SiteHeader.tsx';

// KVKK aydınlatma metni / gizlilik politikası. Statik içerik — veri sorumlusu
// bilgileri ve toplanan veriler bu sistemde gerçekten işlenenlerle birebir.
export function Privacy() {
  return (
    <div className="min-h-dvh">
      <SiteHeader />
      <main className="mx-auto max-w-3xl px-8 pt-16 pb-28">
        <div className="kicker mb-5 text-accent">
          <span className="mr-3 inline-block h-px w-10 align-middle bg-accent" />
          Yasal Bilgilendirme
        </div>
        <h1 className="display text-[clamp(34px,6vw,60px)] font-light leading-[1.04] tracking-tight">
          Gizlilik Politikası ve <em className="italic text-accent">Aydınlatma Metni</em>
        </h1>
        <p className="mt-5 text-[13px] text-text-faint">Son güncelleme: 11 Haziran 2026</p>

        <div className="prose-doc mt-12 space-y-10 text-[15px] leading-relaxed text-text-muted">
          <Section n="1" title="Veri Sorumlusu">
            <p>
              rezervasyon.acarsanatakademi.com üzerinden sunulan etkinlik koltuk rezervasyonu
              hizmeti, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında veri
              sorumlusu sıfatıyla aşağıdaki şirket tarafından yürütülmektedir:
            </p>
            <ul className="mt-4 space-y-1.5 text-text">
              <li>Unvan: Acar Sanat Akademi Eğitim Hizmetleri Ltd. Şti.</li>
              <li>Adres: Uğur Mumcu Mah. Şeyh Şamil Cad. Teknik Yapı Upcity No: 9/2A, Kartal / İstanbul</li>
              <li>Telefon: 0216 475 92 62</li>
              <li>Vergi Dairesi / No: Yakacık V.D. — 0040511100</li>
              <li>Ticaret Sicil No: 91209-5</li>
            </ul>
          </Section>

          <Section n="2" title="İşlediğimiz Kişisel Veriler">
            <p>Bir rezervasyon oluşturduğunuzda yalnızca şu verileriniz işlenir:</p>
            <ul className="mt-4 list-disc space-y-2 pl-5">
              <li>
                <span className="text-text">Kimlik ve iletişim:</span> ad-soyad, e-posta adresi,
                telefon numarası.
              </li>
              <li>
                <span className="text-text">Rezervasyon bilgileri:</span> seçtiğiniz koltuklar,
                rezervasyon referans kodu, etkinlik bilgisi ve varsa eklediğiniz not.
              </li>
              <li>
                <span className="text-text">İşlem güvenliği:</span> rezervasyonun yapıldığı IP
                adresi, cihaz/tarayıcı bilgisi ve işlem zamanı.
              </li>
            </ul>
          </Section>

          <Section n="3" title="İşleme Amaçları">
            <ul className="list-disc space-y-2 pl-5">
              <li>Ön rezervasyon ve rezervasyon kaydınızın oluşturulması ve yönetilmesi,</li>
              <li>
                Rezervasyon onayı, hatırlatma ve bilgilendirmelerin e-posta ve WhatsApp üzerinden
                iletilmesi,
              </li>
              <li>Ödeme ve onay görüşmesi süreçlerinin yürütülmesi,</li>
              <li>
                Aynı koltuğun birden fazla kişiye verilmesinin (çift rezervasyon) önlenmesi ve işlem
                güvenliğinin sağlanması,
              </li>
              <li>İlgili mevzuattan doğan yükümlülüklerin yerine getirilmesi.</li>
            </ul>
          </Section>

          <Section n="4" title="Hukuki Sebepler">
            <p>
              Kişisel verileriniz KVKK m.5 uyarınca; rezervasyon ilişkisinin kurulması ve ifası için
              gerekli olması, şirketimizin işlem güvenliği ve çift rezervasyonun önlenmesine yönelik
              meşru menfaati ile tarafınızca verilen açık rıza hukuki sebeplerine dayanılarak
              işlenir.
            </p>
          </Section>

          <Section n="5" title="Kişisel Verilerin Aktarılması">
            <ul className="list-disc space-y-2 pl-5">
              <li>
                Rezervasyon onay e-postaları, kendi alan adımıza ait mail sunucusu üzerinden
                gönderilir.
              </li>
              <li>
                WhatsApp üzerinden bilgilendirme almanız hâlinde, mesajların iletilebilmesi için
                ad-soyad, rezervasyon ve koltuk bilgileriniz Meta Platforms Ireland Ltd. (WhatsApp)
                altyapısı üzerinden işlenir; bu kapsamda verileriniz yurt dışına aktarılabilir.
              </li>
              <li>
                Verileriniz, bu metinde belirtilen amaçlar dışında üçüncü kişilerle paylaşılmaz ve
                pazarlama amacıyla satılmaz.
              </li>
            </ul>
          </Section>

          <Section n="6" title="Saklama Süresi">
            <p>
              Kişisel verileriniz, rezervasyon ve ilgili etkinlik süreçleri ile yasal saklama
              yükümlülüklerinin gerektirdiği süre boyunca saklanır; bu sürelerin sona ermesinin
              ardından silinir, yok edilir veya anonim hâle getirilir.
            </p>
          </Section>

          <Section n="7" title="KVKK Kapsamındaki Haklarınız">
            <p>
              KVKK m.11 uyarınca; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse
              bilgi talep etme, işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,
              eksik veya yanlış işlenmiş olması hâlinde düzeltilmesini, şartların oluşması hâlinde
              silinmesini veya yok edilmesini isteme, bu işlemlerin verilerin aktarıldığı üçüncü
              kişilere bildirilmesini isteme, münhasıran otomatik sistemlerle yapılan analiz sonucu
              aleyhinize bir sonucun doğmasına itiraz etme ve verilerinizin hukuka aykırı işlenmesi
              sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme haklarına
              sahipsiniz.
            </p>
          </Section>

          <Section n="8" title="Başvuru">
            <p>
              Haklarınıza ilişkin taleplerinizi, yukarıda belirtilen adresimize yazılı olarak ya da
              0216 475 92 62 numaralı telefon üzerinden iletebilirsiniz. Başvurularınız, talebin
              niteliğine göre en geç otuz gün içinde sonuçlandırılır.
            </p>
          </Section>

          <Section n="9" title="Çerezler">
            <p>
              Sistemimiz, yalnızca rezervasyon oturumunuzun sürdürülebilmesi için zorunlu teknik
              oturum bilgisi kullanır. Pazarlama veya takip amaçlı çerez kullanılmaz.
            </p>
          </Section>
        </div>
      </main>
    </div>
  );
}

function Section({ n, title, children }: { n: string; title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="mb-3 flex items-baseline gap-3 text-[17px] font-medium text-text">
        <span className="tnum text-[13px] text-text-faint">{n}</span>
        {title}
      </h2>
      {children}
    </section>
  );
}
